// Request the legacy product modal (`productsVM.openPicker`, components/modals/products.js) hands to the Vue product
// picker : the legacy keeps its filters (picking segments, cross merchandising, competitors, not referenced products) and
// computes the list of a tab on demand ; Vue only renders it. The objects come from the iframe realm : no instanceof.

/** The list of one tab of a request, normalized : `{ items, message }`, never throwing on a missing or failing request. */
export function pickerListOf(request, tab) {
	if (!request || typeof request.list !== 'function') return { items: [], message: '' };
	let result;
	try {
		result = request.list(tab);
	} catch {
		return { items: [], message: '' };
	}
	const items = Array.isArray(result?.items) ? result.items.filter((item) => item && item.id !== undefined && item.id !== null) : [];
	return { items: items.map((item) => ({ ...item })), message: typeof result?.message === 'string' ? result.message : '' };
}
